import {Component, computed, inject, input, model, output, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DxDataGridModule, DxNumberBoxModule, DxPopupModule} from 'devextreme-angular';
import notify from 'devextreme/ui/notify';

import {SharedModule} from '../../../../../shared/shared.module';
import {UtilsService} from '../../../../../core/utils/utils.service';
import {ProduitDeclinaisonService} from '../../../../../core/services/entities/produit-declinaison.service';
import {ProduitDeclinaisonDTO} from '../../../../../core/dtos/produit-declinaison-dto';
import {UniteDeMesureDTO} from '../../../../../core/dtos/unitedemesure-dto';
import {UnitesDeMesuresService} from '../../../../../core/services/entities/unites-de-mesures.service';
import {MSG_KEY, MSG_SEVERITY} from '../../../../../core/constants';
import {ToastService} from '../../../../../core/services/technique/toast.service';
import {ButtonThemeEnum} from '../../../../../shared/ui/button/button-theme-enum';
import {DialogChangeUniteTechniqueHelpComponent} from './dialog-change-unite-technique-help/dialog-change-unite-technique-help.component';

@Component({
  selector: 'yo-dialog-change-unite-technique',
  templateUrl: './dialog-change-unite-technique.component.html',
  styleUrls: ['./dialog-change-unite-technique.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    DxPopupModule,
    DxDataGridModule,
    DxNumberBoxModule,
    DialogChangeUniteTechniqueHelpComponent
  ]
})
export class DialogChangeUniteTechniqueComponent {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  displayDialog = model<boolean>(false);
  denree = input<ProduitDeclinaisonDTO>();
  saved = output<ProduitDeclinaisonDTO>();

  uniteTechniqueSubstitution = signal<UniteDeMesureDTO>(null);
  qteNewUniteDeMesure = signal<number>(null);

  qteOldUniteDeMesure = computed(() => this.denree()?.ratioUniteTechnique > 0 ? this.denree().ratioUniteTechnique : 0);

  public utils = inject(UtilsService);
  public udmSvc = inject(UnitesDeMesuresService);
  #produitDeclinaisonSvc = inject(ProduitDeclinaisonService);
  #toastSvc = inject(ToastService);

  closeDialog = () => {
    this.displayDialog.set(false);
    this.uniteTechniqueSubstitution.set(null);
    this.qteNewUniteDeMesure.set(null);
  };

  onSelectionChanged = (event: any) => {
    this.uniteTechniqueSubstitution.set(event.selectedRowsData[0]);
    this.qteNewUniteDeMesure.set(0);
  };

  saveUniteTechnique = () => {
    this.#produitDeclinaisonSvc.saveChangeUniteTechnique(
      this.denree().id,
      this.uniteTechniqueSubstitution().id,
      this.qteOldUniteDeMesure(),
      this.qteNewUniteDeMesure()
    ).subscribe(response => {
      this.#toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS,
        `Le changement d'unité technique a été réalisé avec succès. Son changement a impacté ${response.one?.dishesWichUsedCurrentFoodStuff.length} recette(s)`);
      this.saved.emit(response.one);
      this.closeDialog();
      if (!this.denree().fabrique) {
        notify({message: 'Pensez à mettre à jour votre stock minimum', width: 'auto', position: 'bottom-right'});
      }
    });
  };
}
